/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum NotificationReceiverType {
    To = 1,
    Cc = 2,
    Bcc = 3,
    From = 4,
}
